import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const inputClasses =
  "shadow-sm appearance-none border border-gray-300 rounded-xl w-full py-3 px-4 text-[#1B1B1F] " +
  "leading-tight focus:outline-none focus:ring-2 focus:ring-[#F2B705] focus:border-[#F2B705] transition-colors";

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    setError('');
    setMessage('');
    setLoading(true);

    if (!email) {
      setError('الرجاء إدخال بريدك الإلكتروني.');
      setLoading(false);
      return;
    }

    setTimeout(() => {
      console.log(`Sending password reset link to: ${email}`);

      setMessage(
        'تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.'
      );

      setEmail('');
      setLoading(false);
    }, 2000);
  };

  return (
    <div
      className="flex items-center justify-center min-h-screen bg-[#F6F5F2] p-4"
      dir="rtl"
    >
      <div className="bg-white p-8 rounded-2xl shadow-[0_2px_10px_rgba(27,27,31,0.08)] w-full max-w-md">
        <div className="text-center mb-6">
          <Link
            to="/"
            className="text-2xl font-extrabold text-[#1B1B1F]"
            style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
          >
            MEME STORE
          </Link>

          <h2
            className="text-2xl font-bold text-[#1B1B1F] mt-4"
            style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
          >
            نسيت كلمة المرور؟
          </h2>

          <p className="text-gray-600 text-sm mt-3 leading-6">
            أدخل بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label
              htmlFor="email"
              className="block text-[#1B1B1F] text-sm font-bold mb-2"
            >
              البريد الإلكتروني
            </label>

            <input
              type="email"
              id="email"
              className={inputClasses}
              placeholder="أدخل بريدك الإلكتروني"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {error && (
            <p className="text-[#FF4D4D] text-xs font-medium mb-4 text-center">
              {error}
            </p>
          )}

          {message && (
            <p className="text-green-600 text-xs font-medium mb-4 text-center">
              {message}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="bg-[#F2B705] hover:bg-[#1B1B1F] text-[#1B1B1F] hover:text-white font-bold py-3 px-6
            rounded-full w-full transition-colors duration-300 disabled:opacity-60 disabled:cursor-not-allowed
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F2B705] focus-visible:ring-offset-2"
          >
            {loading ? 'جاري الإرسال...' : 'إرسال رابط إعادة التعيين'}
          </button>

          <p className="text-center text-gray-600 text-sm mt-6">
            تذكرت كلمة المرور؟{' '}
            <Link
              to="/login"
              className="text-[#1B1B1F] hover:text-[#F2B705] font-bold transition-colors"
            >
              تسجيل الدخول
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
